import Alert from "@mui/material/Alert";

import { buildUnmatchedAssignmentsViewModel } from "../lib/projectAssignments";

import type { TFunction } from "i18next";
import type { UnmatchedAssignment } from "../lib/projectAssignments";

export interface UnmatchedAssignmentsAlertProps {
  unmatched: UnmatchedAssignment[];
  supportReference: string | null;
  t: TFunction;
}

/**
 * Aviso persistente sobre el select de Proyecto: le explica al colaborador que tiene
 * asignaciones activas que no cruzaron con Redmine, en vez de dejarlo con un select
 * vacío sin ninguna pista. No se cierra solo: sigue vigente mientras el diagnóstico
 * de origen siga vigente.
 */
export const UnmatchedAssignmentsAlert = ({
  unmatched,
  supportReference,
  t,
}: UnmatchedAssignmentsAlertProps) => {
  if (!unmatched || unmatched.length === 0) return null;

  const viewModel = buildUnmatchedAssignmentsViewModel(unmatched, supportReference);

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {viewModel.keyedKeys.length > 0 && (
        <div>
          {t("unmatchedAssignmentKeyed", {
            keys: viewModel.keyedKeys.join(", "),
            reference: viewModel.keyedReference,
          })}
        </div>
      )}
      {viewModel.hasNullKeyEntry && (
        <div>{t("unmatchedAssignmentNullKey", { reference: viewModel.nullKeyReference })}</div>
      )}
    </Alert>
  );
};
